/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import type { VNode } from "preact";
import {
  useCategories,
  useInventory,
  useMerchantConfig,
  useTokenFamilies,
  useTokenFamilyDetails,
} from "../api/hooks.js";
import { CreateSubscriptionScreen } from "../screens/CreateSubscriptionScreen.js";

export function CreateSubscriptionRoute({
  editId,
}: {
  editId?: string;
}): VNode {
  const { tokenFamilies, createTokenFamily, updateTokenFamily } =
    useTokenFamilies();
  const { resource: familyResource } = useTokenFamilyDetails(editId);
  const { categories, resource: categoriesResource } = useCategories();
  const { products, resource: productsResource } = useInventory();
  const {
    primaryCurrency,
    currencies,
    resource: configResource,
  } = useMerchantConfig();
  return (
    <CreateSubscriptionScreen
      editId={editId}
      families={tokenFamilies}
      familyResource={familyResource}
      categories={categories ?? []}
      categoriesResource={categoriesResource}
      products={products ?? []}
      productsResource={productsResource}
      primaryCurrency={primaryCurrency}
      currencySpecifications={currencies}
      configResource={configResource}
      onCreateFamily={(f) => createTokenFamily(f as never)}
      onUpdateFamily={(slug, f) => updateTokenFamily(slug, f as never)}
    />
  );
}
